import { render, staticRenderFns } from "./CommunityGroupCard.vue?vue&type=template&id=df837ef6&scoped=true&"
import script from "./CommunityGroupCard.vue?vue&type=script&lang=ts&"
export * from "./CommunityGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityGroupCard.vue?vue&type=style&index=0&id=df837ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df837ef6",
  null
  
)

export default component.exports